/**
 *
 * @param file a blob
 * @returns src and mimeType of the loaded image
 * Should support all our supported images.
 */
export const readImageFiles = (
  file: Blob,
): Promise<{ src: string; mimeType: string }> => {
  /**
   * Must use require because the library depends on Blob from the browser.
   * https://github.com/alexcorvi/heic2any/issues/13
   */
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const heic2any = require('heic2any');
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => {
      if (reader.result) {
        // Image/heic images are converted to jpeg before read by the fileReader
        const mimeType = file.type === 'image/heic' ? 'image/jpeg' : file.type;

        resolve({ src: reader.result as string, mimeType });
      }
    });
    if (file.type === 'image/heic') {
      /**
       * To support heic images we need to use a converter library to convert to
       * jpeg.
       * Then we just plug it into the normal procedure and read the dataUrl as Base64
       * Which then is upload as normal
       */
      heic2any({
        blob: file,
        toType: 'image/jpeg',
      })
        .then((blob: Blob) => {
          reader.readAsDataURL(blob as Blob);
        })
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .catch((e: any) => {
          reject(e);
        });
    } else {
      // Read the file as dataurl to get a base64 data url that we will upload to storage.
      reader.readAsDataURL(file);
    }
  });
};
